module.exports = __webpack_public_path__ + "img/image31.6ee67d4f.jpg";